import { Xmark } from '@gravity-ui/icons';
import { Button, Icon, Sheet } from '@gravity-ui/uikit';

import styles from './blank-block/sheets/styles.module.scss';

export const BlankListFilterSheet = ({ visibleFilter, setVisibleFilter, onSortChange }: any) => {
	return (
		<Sheet
			visible={visibleFilter}
			onClose={() => setVisibleFilter(false)}
			title="Cортировка"
			className={styles.sheet}
		>
			<div className={styles.sheet__close}>
				<Button onClick={() => setVisibleFilter(false)} view="flat">
					<Icon data={Xmark} size={16} />
				</Button>
			</div>
			<div className={styles.sheet__btns}>
				<Button
					size="xl"
					view="flat"
					onClick={() => {
						onSortChange('По дате создания');
						setVisibleFilter(false);
					}}
				>
					По дате создания
				</Button>
				<Button
					size="xl"
					view="flat"
					onClick={() => {
						onSortChange('От А-Я');
						setVisibleFilter(false);
					}}
				>
					По алфавиту А-Я
				</Button>
				<Button
					size="xl"
					view="flat"
					onClick={() => {
						onSortChange('От Я-А');
						setVisibleFilter(false);
					}}
				>
					По алфавиту Я-А
				</Button>
				<Button
					size="xl"
					view="flat"
					onClick={() => {
						onSortChange('Сначала новые');
						setVisibleFilter(false);
					}}
				>
					Сначала новые
				</Button>
			</div>
		</Sheet>
	);
};
